import { Injectable } from '@angular/core';
import { Cfop } from './../model/cfop.model';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

@Injectable()
export class CfopService extends EntityService<Cfop> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'cfop',
      pluralBaseEntityEndPoint: 'cfops',
      urlBackend: configService.backendURL
    });
  }
}
